import customHttp from "../services/customHTTP";

export const launchReach360 = async () => {
	const popup = window.open("about:blank", "_blank");
	if (!popup) {
		const error = new Error("Allow pop-ups to open Reach 360.");
		error.code = "POPUP_BLOCKED";
		throw error;
	}

	try {
		popup.document.title = "Opening Reach 360...";
		popup.document.body.textContent = "Connecting to Reach 360...";
		const response = await customHttp.post("/auth/saml/reach360", {});
		const { samlResponse, acsUrl } = response?.data?.data || {};
		if (!samlResponse || !acsUrl) throw new Error("Reach 360 SSO is not configured yet.");

		const form = popup.document.createElement("form");
		form.method = "POST";
		form.action = acsUrl;
		const field = popup.document.createElement("input");
		field.type = "hidden";
		field.name = "SAMLResponse";
		field.value = samlResponse;
		form.appendChild(field);
		popup.document.body.replaceChildren(form);
		popup.opener = null;
		form.submit();
	} catch (error) {
		popup.close();
		throw error;
	}
};
